import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import * as React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { AudienseEcosystemMenu as AudienseEcosystemMenuReact } from '@audienseco/titan-react';

@Component({
  selector: 'sp-audiense-ecosystem-menu',
  template: '<div #reactRoot></div>',
  standalone: true
})
export class AudienseEcosystemMenu implements AfterViewInit, OnDestroy {
  @ViewChild('reactRoot', { static: true }) reactRootRef!: ElementRef;
  @Input() linkWrapper?: (url: string, children: React.ReactNode) => React.ReactNode;

  private root: Root | null = null;

  ngAfterViewInit(): void {
    this.renderReactComponent();
  }

  ngOnDestroy(): void {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
  }

  private renderReactComponent(): void {
    const props = {
      linkWrapper: this.linkWrapper
    };

    const element = React.createElement(AudienseEcosystemMenuReact, props);

    if (!this.root) {
      this.root = createRoot(this.reactRootRef.nativeElement);
    }

    this.root.render(element);
  }
}
